export default function sendEmail (email, subject, body) {
  const encodedSubject = encodeURIComponent(subject)
  const encodedBody = encodeURIComponent(body)

  const mailtoUrl = `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`

  window.location.href = mailtoUrl
}



// WEBPACK FOOTER //
// ./src/services/sendMessageEmail.js